import type { ReactNode } from "react";

/** Red: needs fixing. Amber: waits for someone. Green: done. Grey: only informs. */
export type ChipTone = "red" | "amber" | "green" | "grey";

const TONE_CLASS: Record<ChipTone, string> = {
  red: "bg-red-100 text-red-800",
  amber: "bg-amber-100 text-amber-800",
  green: "bg-green-100 text-green-800",
  grey: "bg-gray-100 text-gray-700",
};

/** A small coloured label for the state of a row. */
export default function StatusChip({ tone, children }: { tone: ChipTone; children: ReactNode }) {
  return (
    <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium ${TONE_CLASS[tone]}`}>
      {children}
    </span>
  );
}
